import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { left } from '@/utils/directions';
import SidebarCategory from './SidebarCategory';
import SidebarLink, { SidebarLinkTitle } from './SidebarLink';
import { colorBorder, colorBackground, colorHover } from '@/utils/palette';

const SidebarContent = ({
  onClick, collapse,
}) => (
  <SidebarContentWrap collapse={collapse}>
    <SidebarBlock collapse={collapse}>
      <SidebarLink title="Dashboard" icon="home" route="/dashboard" onClick={onClick} />
      <SidebarCategory title="Workspace" icon="earth" collapse={collapse}>
        <SidebarLink title="Users" route="/workspace/users" onClick={onClick} />
        <SidebarLink title="Organizations" route="/workspace/organizations" onClick={onClick} />
        <SidebarLink title="Subscriptions" route="/workspace/subscriptions" onClick={onClick} />
      </SidebarCategory>
      <SidebarCategory title="Marketplace" icon="store" collapse={collapse}>
        <SidebarLink title="API Usages" route="/marketplace/apiusage" onClick={onClick} />
        <SidebarLink title="Print Requests" route="/marketplace/printrequests" onClick={onClick} />
        <SidebarLink title="Crop Requests" route="/marketplace/croprequests" onClick={onClick} />
        <SidebarLink title="Crop Requests Pricing" route="/marketplace/export_pricing" onClick={onClick} />
        <SidebarLink title="Subscription Plans Pricing" route="/marketplace/subscription_pricing" onClick={onClick} />
      </SidebarCategory>
      <SidebarCategory title="Capture" icon="camera" collapse={collapse}>
          <SidebarLink title="Capture Requests" route="/capture/requests" onClick={onClick} />
      </SidebarCategory>
      <SidebarCategory title="Assets" icon="layers" collapse={collapse}>
        <SidebarCategory title="Manage Assets" collapse={collapse}>
          <SidebarLink title="Assets List" route="/assets/assets" onClick={onClick} />
          <SidebarLink title="Create Requests List" route="/assets/create/requests" onClick={onClick} />
          <SidebarCategory title="Create" collapse={collapse}>
            <SidebarLink title="Mosaic" route="/assets/create/mosaic" onClick={onClick} />
            <SidebarLink title="Tileset" route="/assets/create/tileset" onClick={onClick} />
            <SidebarLink title="Web-Service" route="/assets/create/web_service" onClick={onClick} />
            <SidebarLink title="Oblique" route="/assets/create/oblique" onClick={onClick} />
            <SidebarLink title="Streetview" route="/assets/create/streetview" onClick={onClick} />
          </SidebarCategory>
        </SidebarCategory>
        <SidebarCategory title="Manage Files" collapse={collapse}>
          <SidebarLink title="Files List" route="/assets/files/list" onClick={onClick} />
          <SidebarLink title="Upload Files" route="/assets/files/upload" onClick={onClick} />
        </SidebarCategory>
        <SidebarLink title="Missions" route="/assets/missions" onClick={onClick} />
        <SidebarLink title="Collections" route="/assets/collections" onClick={onClick} />
        <SidebarLink title="Providers" route="/assets/providers" onClick={onClick} />
        <SidebarLink title="Licenses" route="/assets/licenses" onClick={onClick} />
        <SidebarLink title="Instruments" route="/assets/intruments" onClick={onClick} />
        <SidebarLink title="Calibrations" route="/assets/calibrations" onClick={onClick} />
      </SidebarCategory>
      <SidebarCategory title="GeoAI" icon="cog" collapse={collapse}>
          <SidebarLink title="Limits" route="/geoai/limits" onClick={onClick} />
          <SidebarLink title="Requests" route="/geoai/requests" onClick={onClick} />
      </SidebarCategory>
    </SidebarBlock>
    <SidebarBlock collapse={collapse}>
      <SidebarLink title="Documentation" icon="text-align-justify" route="/documentation" onClick={() => window.location.href = 'https://fastmap.readme.io/reference'} />
      <SidebarLink title="Back to Workspace" icon="exit" route="/workspace" onClick={() => window.location.href = 'https://earth.fastmap.ai'} />
    </SidebarBlock>
  </SidebarContentWrap>
);

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  collapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  collapse: false,
  onClick: () => { },
};

export default SidebarContent;

// region STYLES

const SidebarContentWrap = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0;
  
  & > div:last-child {
    width: 4px !important;

    div {
      transition: height 0.3s;
      opacity: 0.52;
    }
  }
  
  @media screen and (min-width: 576px) {
    padding-top: 15px;
    
    ${props => props.collapse && `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
  }
`;

const SidebarBlock = styled.ul`
  padding: 15px 0;
  border-bottom: 1px solid ${colorBorder};
  list-style-type: none;
  
  &:last-child {
    border: none;
  }

  ul ul ul {
    padding-left: 15px;
  }
  
  @media screen and (min-width: 576px) {
    
    ${props => props.collapse && `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};
        
        span:last-of-type {
          opacity: 0;
          transition: 0.3s;
        }
  
        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
        }
  
        &:hover {
          background: ${colorHover(props)};
        }
      }
      
      & > li:hover > a,
      & > li:hover > button {
        width: 275px;
        
        span {
          opacity: 1;
        }
      }
    `}
  }
`;

// endregion

